import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}


// corespeed-glp1-nowrap-fallback-20260702
// Page-scoped fallback for a Shopify full-page cache edge case where the clean GLP-1 landing URL can serve stale page-body HTML.
function corespeedGlp1NowrapFallback() {
  if (window.location.pathname !== '/pages/glp-1-support-system') return;
  const headingText = 'Why Essentials+ Is the Recommended GLP-1 Support Protocol';
  const headings = document.querySelectorAll('.cs-glp1-page .cs-reco .cs-h2, .cs-glp1-page h2.cs-h2');
  headings.forEach((heading) => {
    if (heading.textContent.trim() !== headingText || heading.querySelector('.cs-nowrap')) return;
    heading.innerHTML = 'Why Essentials+ Is the Recommended <span class="cs-nowrap">GLP-1</span> Support Protocol';
  });
  if (!document.getElementById('corespeed-glp1-nowrap-style')) {
    const style = document.createElement('style');
    style.id = 'corespeed-glp1-nowrap-style';
    style.textContent = '.cs-glp1-page .cs-nowrap{white-space:nowrap!important}';
    document.head.appendChild(style);
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', corespeedGlp1NowrapFallback, { once: true });
} else {
  corespeedGlp1NowrapFallback();
}
